<template>
<el-drawer title="编辑订单详情" :visible.sync="drawer" :with-header="true" :append-to-body="true">
  <div class="drawer-form">
    <el-form ref="banquetForm" :model="ruleForm" label-position="top">
      <el-form-item label="客资编号">
        <el-input v-model="ruleForm.member_id"></el-input>
      </el-form-item>
      <el-form-item label="订单类型">
        <el-select v-model="ruleForm.news_type" placeholder="请选择">
          <el-option v-for="(item,index) in pickerList.newsTypeList" :key="index" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户姓名">
        <el-input v-model="ruleForm.realname"></el-input>
      </el-form-item>
      <el-form-item label="客户手机号">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="成单门店">
        <el-select v-model="ruleForm.store_id" filterable placeholder="请选择">
          <el-option v-for="(item,index) in pickerList.storeList" :key="index" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="桌数">
        <el-input v-model="ruleForm.table_amount"></el-input>
      </el-form-item>
      <el-form-item label="餐标">
        <el-input v-model="ruleForm.table_price"></el-input>
      </el-form-item>
      <el-form-item label="总价">
        <el-input v-model="ruleForm.totals"></el-input>
      </el-form-item>
      <el-form-item label="婚期">
        <el-date-picker v-model="ruleForm.event_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="订单销售">
        <el-select v-model="ruleForm.sales_id" filterable placeholder="请选择">
          <el-option v-for="(item,index) in pickerList.userList" :key="index" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟单人">
        <el-select v-model="ruleForm.user_id" filterable placeholder="请选择">
          <el-option v-for="(item,index) in pickerList.userList" :key="index" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合同编号">
        <el-input v-model="ruleForm.contract_no"></el-input>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="ruleForm.item_check_status" placeholder="请选择">
          <el-option v-for="(item,index) in statusList" :key="index" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="ruleForm.remark"></el-input>
      </el-form-item>
      <el-form-item label="合同照片">
        <uploadImg :images="ruleForm.images" @changeImg="changeImgFn"></uploadImg>
      </el-form-item>
      <el-form-item class="el-form-item-buttons">
        <el-button type="primary" @click="onSubmit('banquetForm')">提交</el-button>
        <el-button @click="resetForm('banquetForm')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</el-drawer>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      uploadOptions: {},
      drawer: false,
      ruleForm: {
        member_id: '',
        news_type: '',
        contract_no: '',
        realname: '',
        mobile: '',
        store_id: '',
        event_date: '',
        table_amount: '',
        table_price: '',
        totals: '',
        user_id: '',
        sales_id: '',
        remark: '',
        images: [],

      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      pickerList: {},
      statusList: [{
          id: 0,
          title: '待审核'
        },
        {
          id: 1,
          title: '审核通过'
        }
      ]
    };
  },
  created() {
    this.uploadOptions['token'] = localStorage.getItem('token');
    this.getData();
  },
  methods: {
    //获取订单picker
    getData() {
      let that = this
      let url = '/api/order.customer/picker';
      let query = {};
      this.$post(url, query).then(res => {
        if (res.code == 200) {
          that.pickerList = res.data
        }
      });
    },
    handleShow(options) {
      this.drawer = true;
      this.ruleForm = options;
      this.ruleForm.news_type = this.ruleForm.news_type + '';
    },
    //获取要保存的图片
    changeImgFn(img) {
      this.ruleForm.images = img;
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = '/api/order.customer/save';
          let query = this.ruleForm;
          this.$post(url, query).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '编辑成功！！！',
                type: 'success'
              });
              this.drawer = false;
              this.$emit('getInfo', 'ok')
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
      this.drawer = false;
    },
  }
}
</script>

<style lang="less">
@import url('@/assets/css/drawer.less');
</style>
